import { useQuery } from '@tanstack/react-query'
import { Outlet } from 'react-router-dom'
import { billingAPI } from '../api/index'
import { useAnalytics } from '../hooks/useAnalytics'
import { Sidebar } from './Sidebar'
import { SubscriptionBanner } from './SubscriptionBanner'

export function AppShell() {
  // Initialize analytics tracking for all page views and navigation
  useAnalytics()

  const { data: billing } = useQuery({
    queryKey: ['billing-status'],
    queryFn: () => billingAPI.getStatus().then((r) => r.data),
    staleTime: 1000 * 60 * 5,
  })

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar />

      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto">
          <div className="p-6">
            <SubscriptionBanner billing={billing} />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
